export default __webpack_public_path__ + "static/media/ceramol-iage-power-serum.eae29d69.png";